/*
 * Polyfills
 */
import './polyfills/object-fit';

/*
 * Modules
 */
import './modules/testimonial-slider'
import './modules/feature-slider'
import './modules/hamburger-handle'
import './modules/form-validatation'
import './modules/make-range-model'
import './modules/alloys'
import './modules/select-address'
import './modules/livechat'
import './modules/dropzone'
import './modules/modal'